import useDefaultToast from '@/components/useDefaultToast'
import { redirectToGDLogin } from '@/lib/redirectToGDLogin'
import AccountDisabled from '@/modules/session/AccountDisabled'
import AuthErrorNotice from '@/modules/session/AuthErrorNotice'
import OutOfUsersQuota from '@/modules/session/OutOfUsersQuota'
import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { fetchTogglesThunk } from '@/redux/slices/sessionSlice'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { UserStatus } from '@/typings/domain'
import { Redirect, router, usePathname } from 'expo-router'
import { PropsWithChildren, useEffect } from 'react'
import { Platform } from 'react-native'

let pendingDisabledRedirect = false

export default function SystemLayout({ children }: PropsWithChildren) {
  const dispatch = useAppDispatch()
  const toast = useDefaultToast()
  const pathname = usePathname()
  const sessionInitialized = useAppSelector(state => state.session.initialized)
  const signedIn = useAppSelector(state => state.session.signedIn)
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)
  const currentUserError = useAppSelector(state => state.currentUser.error)
  const isOwner = useAppSelector(state => state.currentUser.isOwner)
  const usageAndBalance = useAppSelector(state => state.usageAndBalance)

  useEffect(() => {
    dispatch(fetchCurrentUserThunk())
    dispatch(fetchTogglesThunk())
    dispatch(getUsageAndBalanceThunk())
  }, [dispatch])

  useEffect(() => {
    if (currentUser?.status !== UserStatus.Disabled) {
      pendingDisabledRedirect = false
      return
    }

    if (pathname === '/profile/switchUser') return

    if (!pendingDisabledRedirect) {
      pendingDisabledRedirect = true
      toast.show('当前账号已禁用，请切换账号')
      router.replace('/profile/switchUser')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.status])

  if (!sessionInitialized) {
    return null
  }

  if (!signedIn) {
    if (Platform.OS === 'web') {
      redirectToGDLogin()
      return null
    }
    return <Redirect href="/login" />
  }

  if (currentUserLoaded && currentUser && currentUser.accountDisabled) {
    return <AccountDisabled />
  }

  if (
    currentUserLoaded &&
    !isOwner &&
    usageAndBalance.loaded &&
    usageAndBalance.usersQuota < usageAndBalance.occupiedUsersCount &&
    pathname !== '/profile/switchUser'
  ) {
    return <OutOfUsersQuota />
  }

  if (currentUserLoaded && currentUserError) {
    return <AuthErrorNotice />
  }

  if (!currentUserLoaded || !currentUser) {
    return null
  }

  return children
}
